// App.js
import React, { useState } from "react";
import logo from './logo.svg';
import "./App.css";
import "./NeonButtons.css";

const NeonButton = ({ onClick, label }) => {
  return (
    <a href="#" className="neon-button" onClick={onClick}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      {label}
    </a>
  );
};

function App() {
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [isHeadingMoved, setIsHeadingMoved] = useState(false);
  const [areButtonsHidden, setAreButtonsHidden] = useState(false);

  const messages = {
    english: {
      text: (
        <>
          <p>Dear Friends and Partners,</p>
		 <br/>
          <p>
            As the festive season embraces us once more, We find ourselves
            reflecting on the many years of trust, friendship, and shared
            successes we’ve had together. It has been an absolute privilege to
            know you, both as a valued client and as a cherished friend.
          </p>
		 <br/>
          <p>
            May your holidays be filled with laughter, love, and the warmth of
            those closest to you. Here's to a season of blessings and a New Year
            full of new opportunities!
          </p>
          <p>Wishing you and your family a very Merry Christmas and a prosperous New Year.</p>
		 <br/>
		  <p>Warm regards,</p>
		 <br/>
          <p><strong>Team GFS</strong></p>
        </>
      ),
      audio: "/lang-en.mp3",
    },
    french: {
      text: (
        <>
          <p>Chers amis et partenaires,</p>
		 <br/>
          <p>
            Alors que la saison des fêtes nous enveloppe à nouveau, Nous prenons
            un moment pour réfléchir aux nombreuses années de confiance,
            d’amitié et de succès partagés. C’est un privilège absolu de vous
            compter parmi nos précieux partenaires et amis.
          </p>
          <p>
            En cette période de Noël, Nous tenons à vous exprimer nos plus profonde
            gratitude pour votre soutien indéfectible et le plaisir de
            collaborer ensemble. Que vos fêtes soient remplies de rires,
            d’amour et de la chaleur de vos proches.
          </p>
          <p>Nous vous souhaitons, à vous et à vos familles, un très Joyeux Noël et une Bonne Année.</p>
		 <br/>
		  <p>Chaleureusement,</p>
		 <br/>
          <p><strong>Équipe GFS</strong></p>
        </>
      ),
      audio: "/lang-fr.mp3",
    },
    arabic: {
      text: (
        <>
         <p>أصدقاؤنا وشركاؤنا الأعزاء،</p>
		 <br/>
         <p>مع حلول موسم الأعياد مرة أخرى، يجد فريق GFS نفسه يتأمل في سنوات الثقة والصداقة والنجاحات المشتركة التي قضيناها معًا. إنه لشرف كبير أن نعرفكم، كأصدقاء أعزاء وشركاء موثوقين.</p>
		 <br/>
         <p>في هذا الموسم، يود فريق GFS أن يعبر عن أعمق امتنانه لدعمكم الدائم وسعادة العمل معكم. نتمنى أن تكون عطلاتكم مليئة بالفرح، والمحبة، ودفء أحبائكم.</p>
		 <br/>
         <p>إليكم أطيب التمنيات بموسم مليء بالبركات وعام جديد مليء بالفرص والسعادة!
			نتطلع لمواصلة هذه الرحلة الرائعة معًا في العام القادم.
		 </p>
		 <br/>
         <p>مع أطيب التحيات،</p>
		 <br/>
         <p><strong>فريق GFS</strong></p>
        </>
      ),
      audio: "/lang-ar.mp3",
    },
  };

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    setIsHeadingMoved(true);
    setAreButtonsHidden(true);

    // Play the corresponding audio
    const audio = new Audio(messages[language].audio);
    audio.play();
  };

  return (
    <div className="app-container">
      <div className="logo-container">
		<img src={logo} className="App-logo" alt="logo" />
        <div className="GFS-letters">
          <span className="gfs g">G</span>
          <span className="gfs f">F</span>
          <span className="gfs s">S</span>
        </div>
      </div>
      <h1 className={`app-heading ${isHeadingMoved ? "moved" : ""}`}>
        Season's Greetings from GFS
      </h1>
      {!areButtonsHidden && (
        <div className="button-container">
          <NeonButton
            label="English"
            onClick={() => handleLanguageSelect("english")}
          />
          <NeonButton
            label="Français"
            onClick={() => handleLanguageSelect("french")}
          />
          <NeonButton
            label="العربية"
            onClick={() => handleLanguageSelect("arabic")}
          />
        </div>
      )}
      {selectedLanguage && (
        <div className="message">{messages[selectedLanguage].text}</div>
      )}
    </div>
  );
}

export default App;

